module.exports = __webpack_public_path__ + "static/media/pizza.06ad65cc.jpg";